import React, {useEffect, useState} from 'react';
// import Navbar from "../../../components/navbar/Navbar";
// import ScrollButton from '../../../components/scrollButton/scrollButton';
import theme25 from "../../../assets/theme25.png";
import logo_23 from "../../../assets/2024_logo.png";
import logo_25 from "./Memories_Images/logo.png";
// import Footer from "../../../components/footer/Footer"
import styles from "./Event_25.module.css";
import Modal from "./Modal"
import Card from "./speakerCard";
import Card2 from "./memberCard";
import Data from "./speaker'25_Data"
import Bipul from "./speakers25/bipulFc.png"
import Lima from "./speakers25/limaFc.png"
import Lima1 from "./speakers25/limaF.png"
import Rajni from "./speakers25/rajniFc.png"
import Rhea from "./speakers25/rheaFc.png"
import Riten from "./speakers25/ritenFc.png"
import Shankuraj from "./speakers25/shankurajFc.png"
import Sneha from "./speakers25/snehaFc.png"
import Vijaya from "./speakers25/vijayaFc.png"
import Meghana from "./team25/Meghana_Nelapati.jpg"
import Atharva from "./team25/Atharva_Sant.jpg"
import Ayush from "./team25/Ayush_Agarwal.jpg"
import Devesh from "./team25/Devesh_Kamble.jpg"
import Dharani from "./team25/Dharani.jpg"
import Divya from "./team25/Divya_Sahithi.jpg"
import Japleen from "./team25/Japleen_Kaur.jpg"
import Naman from "./team25/Naman_Sharma.jpg"
import Pranati from "./team25/Pranati_Tandon.jpg"
import Shubham from "./team25/Shubham_Yadav.jpg"
import Tanvi from "./team25/Tanvi_Doshi.jpg"
import Anaswara from "./team25/Anaswara.jpg"
import AboutCarousel from './gallerycarousel';

// import Newsletter from '../../../components/Newsletter/newsletter';

const Event_25 = () => {
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  const openModal = ({name, about, description, image, youtubeLink}) => {
    setSelectedSpeaker({name, about, description,image, youtubeLink});
  };

  const closeModal = () => {
    setSelectedSpeaker(null);
  };

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div>
      <div id={styles.body}>
        <header>
          <div>
            <img src={logo_25} alt="theme logo" />
            <div id={styles.theme}>
              <h1>Theme 2025:</h1>
              <h1>Seaside Citadel</h1>
            </div>
          </div>
          <h2>February 09, 2025</h2>
        </header>
        <main>
          <div id={styles.banner}>
            <img src={theme25} alt="theme'25" />
          </div>
          <div id={styles.about}>
            <h2>About</h2>
            <p>
            The theme of TEDxIITGuwahati 2025 is Seaside Citadel, which explores the beauty of creation in the face of impermanence.Imagine a majestic citadel rising from the shore, sculpted from grains of sand—its walls are sturdy, its towers high. For a moment, it stands proudly against the horizon, embodying strength and intention. Yet, just as the tides are inevitable, so too is the fate of this sand-built citadel. The waves come, reshaping it into something new, reminding us of the transient nature of all things we build.
            However, the temporary nature of our creations, does not lessen the importance of our efforts. Is the purpose only to achieve a lasting result, or is there deeper meaning in the act of building itself ? Should we continue to pursue something, knowing that it may or may not last forever--just for the joy we find in it? It speaks to those who build, innovate, or dream with the understanding that the result may not be permanent.
            The Seaside Citadel is a reminder that the beauty of what we build lies not in its endurance, but in the moments of creation and in the lessons learned in the process. It encourages us to revel in the act of building, knowing that the tides will come, and that’s okay. For even as the citadel falls to the sea, the lessons, memories, and experiences we gain from the journey remain within us.
            </p>
          </div>
          <div className={styles.gallery}>
                      <h2>Memories</h2>
                      <div classname={styles.galleryContainer}>
                        <AboutCarousel />
                      </div>
                    </div>
          <div id={styles.speakers}>
            <h2>Speakers</h2>
            <div id={styles.speakerContainer}>
            <Card func={() => openModal({ name: 'Rhea Singha', about: 'Miss Universe India 2024', description: `${Data.Rhea}`, image: `${Rhea}`, youtubeLink:'Tc_8N8WqAYQ' })} name='Rhea Singha' id='#Rhea' image={Rhea} />
            <Card func={() => openModal({name: 'Lima Das',about: 'Actress, Classical Dancer, Vocalist, Former Dental Surgeon',description: `${Data.Lima}`,image: `${Lima}`, youtubeLink:'rEUKE4IbKRk'})} name='Lima Das' id='#Lima' image={Lima} />
            <Card func={() => openModal({name: 'Riten Debnath',about: 'Entrepreneur, CEO of Fueler, Tech Innovator',description: `${Data.Riten}`,image: `${Riten}`, youtubeLink:'CYjQKEzq3Dw'})} name='Riten Debnath' id='#Riten' image={Riten} />
            <Card func={() => openModal({name: 'Vijaya Aswani',about: 'Illustrator, Creative Storyteller, Art Curator',description: `${Data.Vijaya}`,image: `${Vijaya}`, youtubeLink:'CKZvaL8m8Xs'})} name='Vijaya Aswani' id='#Vijaya' image={Vijaya} />
            <Card func={() => openModal({name: 'Shankuraj Konwar',about: 'Singer-Songwriter, Assamese music icon',description: `${Data.Shankuraj}`,image: `${Shankuraj}`, youtubeLink:'nraoCcSX1vM'})} name='Shankuraj Konwar' id='#Shankuraj' image={Shankuraj} />
            <Card func={() => openModal({name: 'Rajni Basumatary',about: 'Filmmaker, Actor, Director, Cultural Change-Maker',description: `${Data.Rajni}`,image: `${Rajni}`, youtubeLink:'IaSv4JE1-PM'})} name='Rajni Basumatary' id='#Rajni' image={Rajni} />
            <Card func={() => openModal({name: 'Bipul Bhuyan',about: 'Experimental Physicist, IIT Guwahati, Neutrino Researcher',description: `${Data.Bipul}`,image: `${Bipul}`, youtubeLink:''})} name='Bipul Bhuyan' id='#Bipul' image={Bipul} />
            <Card func={() => openModal({name: 'Sneha Roy',about: 'Poet, Researcher, Speaker, Gender and Literature Scholar',description: `${Data.Sneha}`,image: `${Sneha}`, youtubeLink:'WOWX3nt5ztg'})} name='Sneha Roy' id='#Sneha' image={Sneha} />
            
            </div>
          </div>
          <div id={styles.team}>
            <h2>Organizing Team</h2>
            <div id={styles.teamContainer}>
            <Card2 name='Pranati Tandon' about='Licensee' image={Pranati}/>
            <Card2 name='Devesh Kamble' about='Co-Licensee & Marketing Head' image={Devesh}/>
            <Card2 name='Tanvi Doshi' about='Content Head' image={Tanvi}/>
            <Card2 name='Shubham Yadav' about='Content Core' image={Shubham}/>
            <Card2 name='Meghana Nelapati' about='WebOps Head' image={Meghana}/>
            <Card2 name='Dharani Lunavath' about='Creatives Head' image={Dharani}/>
            <Card2 name='Atharva Sant' about='Events Head' image={Atharva}/>
            <Card2 name='Naman Sharma' about='Events Core' image = {Naman}/>
            <Card2 name='Japleen Kaur' about='Speakers Head' image={Japleen}/>
            <Card2 name='Anaswara' about='Speaker Core' image={Anaswara}/>
            <Card2 name='Divya Sahiti' about='PR & Media Head' image={Divya}/>
            <Card2 name='Aayush Agarwal' about='PR & Media Core' image={Ayush}/>
        
            </div>
          </div>
        </main>


        {selectedSpeaker && (
          <Modal
            name={selectedSpeaker.name}
            about={selectedSpeaker.about}
            image={selectedSpeaker.image}
            description = {selectedSpeaker.description}
            func={closeModal}
            youtubeLink={selectedSpeaker.youtubeLink}
          />
        )}
        {selectedSpeaker && <div onClick={closeModal} id={styles.overlay}></div>}

      </div>
    </div>
  );
};

export default Event_25;